import { render } from "./dangjCreate.vue?vue&type=template&id=952296ac"
import script from "./dangjCreate.vue?vue&type=script&lang=js"
export * from "./dangjCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__